module.exports = __webpack_public_path__ + "img/kitchen_thumb.8d565317.jpg";